import {
  FileCard,
  FormField,
  PanelSection,
  Upload,
} from '@dev-spendesk/grapes';
import React from 'react';
import { Trans } from 'react-i18next';

import { useTranslation } from 'common/hooks/useTranslation';

import { type FormValues } from './SupplierForm';
import {
  SupplierFileViewer,
  type MediaType,
} from '../SupplierFileViewer/SupplierFileViewer';
import { type Supplier } from '../supplier';

type Props = {
  values: FormValues;
  onShowBankProofFile: (
    bankProofFile?: Supplier['details']['bankProofFile'],
  ) => void;
  onUploadBankProofFile: (file: File) => void;
  onDeleteBankProofFile: () => void;
  showBankProofFileInline: boolean;
};

export const ProofOfBankDetailsSection = ({
  values,
  onShowBankProofFile,
  onUploadBankProofFile,
  onDeleteBankProofFile,
  showBankProofFileInline,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <PanelSection title={t('submitMyInvoice.supplier.proof')}>
      {values.bankProofFile ? (
        <FileCard
          title={values.bankProofFile.filename}
          mimeType={values.bankProofFile.mimetype ?? undefined}
          onClick={() => onShowBankProofFile(values.bankProofFile)}
          onDelete={onDeleteBankProofFile}
        />
      ) : (
        <FormField
          label={t('submitMyInvoice.supplier.proofLabel')}
          description={t('submitMyInvoice.fields.bankProofFile.description')}
        >
          <Upload
            content={
              <Trans i18nKey="forms.uploadFiles.content">
                <br />-<span className="Upload__link">-</span>
              </Trans>
            }
            activeDragContent={t('forms.uploadFiles.activeDragContent')}
            onUpload={(files) => onUploadBankProofFile(files[0])}
          />
        </FormField>
      )}
      {showBankProofFileInline && values.bankProofFile && (
        <SupplierFileViewer
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          fileMediaType={values.bankProofFile.mimetype! as MediaType}
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          fileUrl={values.bankProofFile.viewUrl!}
        />
      )}
    </PanelSection>
  );
};
